import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ spacing }) => ({
    ui_skeleton: {
        margin: ({ m }) => {
            if (typeof m === "number") {
                return spacing(m);
            }
            else if (m instanceof Array) {
                return m.reduce((line, num, idx) => line + `${spacing(num)}px${idx === m.length - 1 ? "" : " "}`, "");
            }
            else {
                return undefined;
            }
        },
    },
    ui_skeleton__variant_card: {
        borderRadius: spacing(0.5),
    },
}));
//# sourceMappingURL=ui_skeleton.css.js.map